<template>
  <page-list
    :list="list"
    :columns="columns" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import { getNameFilter } from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'BillManagerList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_bills',
        getParams: this.getParam,
        filterOptions: {
          id: {
            label: this.$t('scope.text_451'),
          },
          title: getNameFilter({ label: this.$t('scope.text_439'), field: 'title' }),
          billing_account_id: {
            label: this.$t('scope.text_406'),
          },
          subscription_id: {
            label: this.$t('scope.text_452'),
          },
          type: {
            label: this.$t('scope.text_453'),
            dropdown: true,
            filter: true,
            items: [
              { label: this.$t('scope.text_425'), key: 'subscription' },
              { label: this.$t('scope.text_454'), key: 'commodity' },
            ],
            formatter: val => {
              return `type.equals(${val})`
            },
          },
          status: {
            label: this.$t('scope.text_426'),
            dropdown: true,
            items: [
              { label: this.$t('scope.text_427'), key: 'init' },
              { label: this.$t('scope.text_455'), key: 'open' },
              { label: this.$t('scope.text_456'), key: 'cancelled' },
              { label: this.$t('scope.text_457'), key: 'close' },
              { label: this.$t('scope.text_436'), key: 'onpay' },
              { label: this.$t('scope.text_458'), key: 'due' },
              { label: this.$t('scope.text_437'), key: 'paid' },
              { label: this.$t('scope.text_459'), key: 'revoke' },
            ],
          },
        },
      }),
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillSidePage', {
        id: row.id,
        resource: 'billing_bills',
        getParams: this.getParam,
        currentTab: 'bill-order-list',
      }, {
        list: this.list,
      })
    },
  },
}
</script>
